import { Banner, EditBanner, Stores } from "../types";
import { makeAutoObservable } from "mobx";
import api from "../services/api";

export class BannerStore {
  stores: Stores;

  banners: Banner[] = [];

  banner: Banner | undefined = undefined;

  isLoading = false;

  bannersFilters: {
    [dataKey: string]: string | string[];
  } = {};

  constructor(stores: Stores) {
    this.stores = stores;

    makeAutoObservable(this);
  }

  getBanners = async () => {
    this.isLoading = true;
    try {
      let banners = await api.getBanners();
      this.banners = banners;
    } catch (err) {
      throw err;
    } finally {
      this.isLoading = false;
    }
  };

  addBanner = async (data: EditBanner) => {
    this.isLoading = true;
    try {
      let banner = await api.addBanner(data);
      this.banners.unshift(banner);
    } catch (err) {
      throw err;
    } finally {
      this.isLoading = false;
    }
  };

  updateBanner = async (data: EditBanner) => {
    this.isLoading = true;
    try {
      let updateBanner = await api.updateBanner(data);
      this.banners = this.banners.map((banner) =>
        banner.id === updateBanner.id ? updateBanner : banner
      );
    } catch (err) {
      throw err;
    } finally {
      this.isLoading = false;
    }
  };

  deleteBanner = async (id: string) => {
    this.isLoading = true;
    try {
      await api.deleteBanner(id);
      this.banners = this.banners.filter(
        (banner) => banner.id !== (id as unknown as number)
      );
    } catch (err) {
      throw err;
    } finally {
      this.isLoading = false;
    }
  };
}
